import { useState, useEffect } from "react";
import AppHeader from "./../../../components/common/appHeader/AppHeader";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useNavigate } from "react-router-dom";
import { setWeddingType } from "@src/@slice/recommendHallSlice";
import { useRecommendHall } from "./../../../utils/hooks/useRecommendHall";
import Blank from "../../../components/common/blank/Blank";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";

import ImageSelectableCard from "@src/components/recommend/ImageSelectableCard";

import separate from "@assets/images/recommend/weddinghall/seremony_separate.jpg";
import simultaneous from "@assets/images/recommend/weddinghall/seremony_simultaneous.jpg";
import _ from "lodash";

import { closeWebview } from "@src/utils/route";

// const hallTypes = ["동시", "분리", "상관없음"];
const hallTypes = [
  { title: "분리", subTitle: "예식과 피로연 공간이 분리", src: separate },
  { title: "동시", subTitle: "피로연장 이동없이 식사진행", src: simultaneous },
];

const Type = () => {
  const navigate = useNavigate();

  const [validate, setValidate] = useState(false);
  const { dispatch, hallData } = useRecommendHall();
  const [types, setTypes] = useState(
    hallData.weddingType === "상관없음"
      ? ["분리", "동시"]
      : hallData.weddingType === ""
        ? []
        : [hallData.weddingType],
  );
  useEffect(() => {
    setValidate(types.length > 0);
  }, [hallData.weddingType, types]);

  // useEffect(() => {
  //   if (hallData.hallStyleTypes.length === 0) {
  //     navigate("/recommend/hall/start", { replace: true });
  //   }
  // }, []);

  const goNext = () => {
    const type = types.length === 2 ? "상관없음" : types[0];
    dispatch(setWeddingType({ type: type }));
    navigate("/recommend/hall/region");
  };

  return (
    <div>
      <CustomHeader goBack={() => navigate("/recommend/hall/style")} close={closeWebview} />
      {/* <AppHeader type="stack" actionItems={[{ name: "close" }]} /> */}
      {/* <div className="layout-fix-button with-app-header"> */}
      <div className="hall-recommend-layout-fix-button">
        <div>
          <PageTitle
            title={`선호하는 예식 형태를
						모두 선택해 주세요.`}
            type=""
          />
          <div className="common-wrap">
            <div style={{ height: 20 }} />
            <div className="hall-recommend-grid-layout columns-2">
              {hallTypes.map((type) => (
                <ImageSelectableCard
                  key={`style-item-${type.title}`}
                  src={type.src}
                  checked={types.indexOf(type.title) > -1}
                  onClick={() => {
                    if (types.includes(type.title)) {
                      setTypes((prev) => prev.filter((t) => t !== type.title));
                    } else {
                      setTypes((prev) => [...prev, type.title]);
                    }
                  }}
                />
              ))}
            </div>
          </div>
        </div>
        <div>
          <div className="gradient-background"></div>
          <button
            onClick={goNext}
            className={`btn btn-giant btn-red500 btn-full ${!validate ? "btn-disabled" : ""}`}
            disabled={!validate}
          >
            다음
          </button>
        </div>
      </div>
    </div>
  );
};

export default Type;
